import { useGLTF } from "@react-three/drei";
import React from "react";
import { MathUtils } from "three";
import { MeshBasicMaterial, DoubleSide } from "three";
import { useClient } from "../../shared/hooks/client-hook";

const CameraDummy = () => {
  const { scene } = useGLTF("/gltf/camDummy.glb");
  const { client } = useClient();

  const wireMaterial = new MeshBasicMaterial({
    color: 0xffffff,
    side: DoubleSide,
  });

  scene.traverse((child) => {
    if (child.type === "Mesh" || child.type === "SkinnedMesh") {
      child.material = wireMaterial;
      child.castShadow = false;
      child.receiveShadow = false;
    }
  });

  if (!client || !client.camera || !client.camera.position) {
    return null;
  }

  return (
    <primitive
      object={scene}
      position={[
        client.camera.position[0],
        client.camera.position[1],
        client.camera.position[2],
      ]}
      rotation={[0, MathUtils.degToRad(client.camera.rotation), 0]}
    ></primitive>
  );
};

export default CameraDummy;
